import loadable from "@loadable/component"

export const OrganizationDetailsView = loadable(() =>
  import(
    /* webpackChunkName: "organization-detail-chunk" */
    /* webpackPrefetch: true */
    "./components/OrganizationDetailsView"
  )
)
